import {
	ADMINGETCURRENCYMASTER_SUCCESS,
	ADMINGETCURRENCYMASTER_FAILED,
	RESET_ADMINGETCURRENCYMASTER,
	LOADING_ADMINGETCURRENCYMASTER,
	NETWORK_ERROR_ADMINGETCURRENCYMASTER
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetCurrencyMaster = () => {
	return { type: RESET_ADMINGETCURRENCYMASTER };
};

const adminGetCurrencyMaster = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINGETCURRENCYMASTER });
	await adminServices
		.post("getAdminCurrencyMasterList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminGetCurrencyMastersuccess(res.data));
					break;
				default:
					dispatch(adminGetCurrencyMasterFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINGETCURRENCYMASTER,
				payload: err
			});
		});
};
function adminGetCurrencyMastersuccess(data) {
	return {
		type: ADMINGETCURRENCYMASTER_SUCCESS,
		payload: data
	};
}
function adminGetCurrencyMasterFailed(data) {
	return {
		type: ADMINGETCURRENCYMASTER_FAILED,
		payload: data
	};
}

export { resetAdminGetCurrencyMaster, adminGetCurrencyMaster };
